import React from 'react'

const Footer = () => (
  <div>
    &copy; Copyright 2020 Envoy, Inc. / The Honey Badgers
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js